import request from '@/utils/request'


// 查询汽车配置列表
export function listCarConfig(query) {
  return request({
    url: '/carConfig/carConfig/list',
    method: 'get',
    params: query
  })
}

// 查询汽车配置分页
export function pageCarConfig(query) {
  return request({
    url: '/carConfig/carConfig/page',
    method: 'get',
    params: query
  })
}

// 查询汽车配置详细
export function getCarConfig(data) {
  return request({
    url: '/carConfig/carConfig/detail',
    method: 'get',
    params: data
  })
}

// 新增汽车配置
export function addCarConfig(data) {
  return request({
    url: '/carConfig/carConfig/add',
    method: 'post',
    data: data
  })
}

// 修改汽车配置
export function updateCarConfig(data) {
  return request({
    url: '/carConfig/carConfig/edit',
    method: 'post',
    data: data
  })
}

// 删除汽车配置
export function delCarConfig(data) {
  return request({
    url: '/carConfig/carConfig/delete',
    method: 'post',
    data: data
  })
}
